import track10sVisibility from '@/components/Track10sVisibility'

const gtmTracking = () => {
  const triggerLabel = 'data-gtm-trigger'
  const triggerLabelClick = `[${triggerLabel}="click"]`
  const triggerElements = document.querySelectorAll(triggerLabelClick)

  triggerElements.forEach((item) => {
    item.addEventListener('click', (e) => {
      const data = e.currentTarget.dataset

      if (!data || !data.gtmTracking) {
        return
      }

      window.dataLayer.push(JSON.parse(data.gtmTracking))
    })
  })

  const trackTitleOnLoad = (type) => {
    const url = window.location.href
    const title = document.getElementsByTagName('h1')[0]?.innerText

    if (url.includes(type) && url.split('/').reverse()[1] !== type) {
      if (type === 'recipes') {
        window.dataLayer.push({
          recipeName: title
        })
      } else {
        window.dataLayer.push({
          productName: title
        })
      }
    }
  }
  trackTitleOnLoad('recipes')
  trackTitleOnLoad('products')

  const ingredients = document.getElementById('ingredients')
  const instructions = document.getElementById('instructions')

  if (ingredients !== null) {
    track10sVisibility(ingredients, {
      event: 'viewRecipeIngredients10s'
    })
  }

  if (instructions !== null) {
    track10sVisibility(instructions, {
      event: 'viewRecipeInstructions10s'
    })
  }
}

export default gtmTracking
